// extracted by mini-css-extract-plugin
export default {"Placeholder":"waitView_Placeholder__bnt1H","WatiingRender":"waitView_WatiingRender__G5XoC","Mask":"waitView_Mask__qu6kt"};